// src/utils/analytics.js
import { getGAEventTracker } from '../services/apiServices';

// Page view tracking with gtag.js
export const trackPageView = (url) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', process.env.REACT_APP_GA_TRACKING_ID, {
            page_path: url,
            page_title: document.title
        });
    }
};

// Your main event tracking function - migrated to gtag.js
// export async function googleAnalytic(flName, category, action, label, value) {
//     const response = await getGAEventTracker();

//     if (!response) {
//         console.log('No response from GA event tracker');
//         return;
//     }

//     if (response === "false") {
//         console.log('GA tracking disabled by response');
//         return;
//     }

//     const record = await response.json();
//     if (!record) {
//         console.log('No record data received');
//         return;
//     }

//     console.log(record, 'record');

//     const filteredfile = record && record.length > 0 ?
//         record.find(item => item.filename === flName) : {};

//     if (filteredfile.value === "1") {
//         // Migrated to gtag.js
//         if (typeof window !== 'undefined' && window.gtag) {
//             // window.gtag('event', action, {
//             //     event_category: category,  // Keep for backward compatibility
//             //     event_label: label,        // Keep for backward compatibility
//             //     value: value,
//             //     filename: flName, 
//             //     custom_label: label,
//             //     gym_name: JSON.parse(localStorage.getItem("loggedUserInfo")).gymname,    
//             //     gymid_id: JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid,
//             //     timestamp: new Date().toISOString()
//             // });

//             console.log(`GA Event Tracked - ${category}: ${action}, Label: ${label}`);
//         } else {
//             console.warn('gtag not available');
//         }
//     } else {
//         console.log(`GA Event Skipped - ${flName} tracking is disabled`);
//         return;
//     }
// }

function sanitizeUserName(name) {
    if (!name) return 'unknown';
    return String(name).replace(/[^a-zA-Z0-9_-]/g, '');
}

// Enhanced version with additional parameters
export async function googleAnalyticEnhanced(flName, category, action, label, role, additionalParams = {}) {

    if (typeof window !== 'undefined' && window.gtag) {
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo") || "{}");

        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            filename: flName,
            action_by: role,
            // gymid: sanitizeUserName(userInfo.gymid),
            // gym_name: JSON.parse(localStorage.getItem("loggedUserInfo")).gymname,
            // member_name: sanitizeUserName(userInfo.name),
            timestamp: new Date().toISOString(),
            ...additionalParams
        });
    }

}


export const trackButtonClick = async (flName, buttonName, role, additionalData = {}) => {



    let gymid = "";
    let gym_name = "";
    let member_name = "";
    if (role == "staff") {
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo") || "{}");

        gymid = sanitizeUserName(userInfo.gymid);
        gym_name = sanitizeUserName(userInfo.gymname);
        member_name = sanitizeUserName(userInfo.name)
    } else {
        const memberInfo = JSON.parse(localStorage.getItem("memberinfo") || "{}");
        const userinfo = JSON.parse(localStorage.getItem("loggedMemberInfo"))
        gymid = memberInfo?.gymid ? sanitizeUserName(memberInfo.gymid) : additionalData.gymid;
        gym_name = userinfo?.gymname ? sanitizeUserName(userinfo.gymname) : additionalData.gymname;
        member_name = memberInfo?.username ? sanitizeUserName(memberInfo.username) : additionalData.username
    }
    console.log(gymid, gym_name, member_name, 'testinggggg');

    await googleAnalyticEnhanced(
        flName,
        'UI Interaction',
        'button_click',
        buttonName,
        role,
        {
            button_name: buttonName,
            gymid,
            gym_name,
            member_name,
            ...additionalData
        }
    );
};

// export const trackFormSubmission = async (flName, formName, isSuccess = true, formData = {}) => {
//     await googleAnalyticEnhanced(
//         flName,
//         'Form',
//         'form_submit',
//         formName,
//         isSuccess ? 1 : 0,
//         {
//             form_name: formName,
//             success: isSuccess,
//             ...formData
//         }
//     );
// };